import React, { useEffect, useMemo, useState } from 'react';

const serviceCards = [
  {
    image: '/images/water_treatment_updated.jpeg',
    alt: 'Water treatment system',
    title: 'Water Treatment',
    text: 'Advanced treatment systems designed for consistent water quality, operational reliability, and low maintenance.',
    delay: ''
  },
  {
    image: '/images/waste_water_treatment.jpeg',
    alt: 'Wastewater treatment plant',
    title: 'Wastewater Treatment',
    text: 'Efficient wastewater process solutions for sewage, industrial discharge, reuse, and compliance-driven operations.',
    delay: ' delay-1'
  },
  {
    image: '/images/HVAC.jpeg',
    alt: 'HVAC installation',
    title: 'HVAC Systems',
    text: 'Precision climate-control systems for commercial and industrial environments with strong airflow and energy performance.',
    delay: ' delay-2'
  },
  {
    image: '/images/fire_fighting.jfif',
    alt: 'Fire fighting system installation',
    title: 'Fire-Fighting',
    text: 'Dependable fire protection systems that support life safety, asset protection, and fast emergency response readiness.',
    delay: ' delay-3'
  }
];

const industries = [
  'Food & Beverages', 'Hospital & Health Care', 'Educational Institutions', 'Factories',
  'Automobile', 'Chemical & Pharmaceutical', 'Real Estate', 'Refineries', 'Paints',
  'EPC Projects', 'Thermal Station', 'Municipal Corporation', 'Hotels', 'Residence'
];

const projectCards = [
  {
    image: '/images/project_work_1.jpeg',
    alt: 'Project work 1',
    title: 'Process Installation',
    text: 'Integrated treatment setup with clean piping and operational layout.',
    delay: ''
  },
  {
    image: '/images/project_work_2.jpeg',
    alt: 'Project work 2',
    title: 'Site Implementation',
    text: 'Execution-focused deployment built for real-world industrial conditions.',
    delay: ' delay-1'
  },
  {
    image: '/images/project_work_3.jpeg',
    alt: 'Project work 3',
    title: 'Engineering Delivery',
    text: 'Fabricated and assembled system components prepared for field performance.',
    delay: ' delay-2'
  }
];

const galleryImages = [
  { src: '/images/photo_gallery_1.jpeg', alt: 'Gallery image 1' },
  { src: '/images/photo_gallery_2.jpeg', alt: 'Gallery image 2' },
  { src: '/images/photo_gallery_3.jpeg', alt: 'Gallery image 3' },
  { src: '/images/photo_gallery_4.jpeg', alt: 'Gallery image 4' },
  { src: '/images/photo_gallery_5.jfif', alt: 'Gallery image 5' },
  { src: '/images/photo_gallery_6.jfif', alt: 'Gallery image 6' },
  { src: '/images/photo_gallery_7.jfif', alt: 'Gallery image 7' },
  { src: '/images/water_treatment.jfif', alt: 'Gallery image 8' },
  { src: '/images/photo_gallery_9.jpeg', alt: 'Gallery image 9' },
  { src: '/images/photo_gallery_10.jpeg', alt: 'Gallery image 10' },
  { src: '/images/photo_gallery_11.jpeg', alt: 'Gallery image 11' },
  { src: '/images/photo_gallery_12.jpeg', alt: 'Gallery image 12' },
  { src: '/images/photo_gallery_13.jpeg', alt: 'Gallery image 13' }
];

const heroSlides = [
  { src: '/images/home_1.jpeg', alt: 'Nature and technology inspired sustainability visual' },
  { src: '/images/home_2.jpeg', alt: 'Earth and clean water sustainability visual' },
  { src: '/images/home_3.jpeg', alt: 'home 3 visual' }
];

const navItems = [
  { href: '#home', label: 'Home' },
  { href: '#about', label: 'About' },
  { href: '#services', label: 'Services' },
  { href: '#projects', label: 'Projects' },
  { href: '#gallery', label: 'Gallery' },
  { href: '#contact', label: 'Contact' }
];

function App() {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('home');
  const [slideIndex, setSlideIndex] = useState(0);
  const [submitLabel, setSubmitLabel] = useState('Send enquiry');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const repeatedGallery = useMemo(() => [...galleryImages, ...galleryImages], []);

  useEffect(() => {
    const revealElements = document.querySelectorAll('.reveal');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      },
      { threshold: 0.16 }
    );

    revealElements.forEach((element) => observer.observe(element));

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const sections = Array.from(document.querySelectorAll('main section[id]'));
    const setCurrentLink = () => {
      const y = window.scrollY + 120;
      let currentId = sections[0] ? sections[0].id : 'home';
      sections.forEach((section) => {
        if (y >= section.offsetTop) {
          currentId = section.id;
        }
      });
      setActiveSection(currentId);
    };

    window.addEventListener('scroll', setCurrentLink);
    setCurrentLink();

    return () => window.removeEventListener('scroll', setCurrentLink);
  }, []);

  useEffect(() => {
    if (heroSlides.length <= 1) {
      return undefined;
    }

    const timer = window.setInterval(() => {
      setSlideIndex((current) => (current + 1) % heroSlides.length);
    }, 4200);

    return () => window.clearInterval(timer);
  }, []);

  const handleNavClick = () => {
    setIsNavOpen(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitLabel('Enquiry ready to connect');
    setIsSubmitting(true);

    window.setTimeout(() => {
      setSubmitLabel('Send enquiry');
      setIsSubmitting(false);
    }, 2200);
  };

  return (
    <>
      <div className="site-bg"></div>
      <header className="header" id="top">
        <div className="container nav-wrap">
          <a href="#home" className="brand" onClick={handleNavClick}>
            <div>
              <strong>SAMRUDDHI ENVIROTECH SOLUTIONS</strong>
              <span>Excellence in every step</span>
            </div>
          </a>
          <button
            className="nav-toggle"
            id="navToggle"
            aria-label="Toggle navigation"
            onClick={() => setIsNavOpen((current) => !current)}
          >
            <span></span><span></span><span></span>
          </button>
          <nav className={`nav${isNavOpen ? ' is-open' : ''}`} id="navMenu">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className={activeSection === item.href.slice(1) ? 'active' : ''}
                onClick={handleNavClick}
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      </header>

      <main>
        <section className="hero" id="home">
          <div className="hero-slides">
            {heroSlides.map((slide, index) => (
              <img
                key={slide.src}
                src={slide.src}
                alt={slide.alt}
                className={`hero-slide${index === slideIndex ? ' is-active' : ''}`}
              />
            ))}
          </div>
          <div className="hero-overlay"></div>
          <div className="container hero-grid">
            <div className="hero-copy reveal">
              <div className="slogan">Conserve Today, Sustain Tomorrow</div>
              <h1>Engineering sustainable systems with precision, reliability, and technical depth.</h1>
              <p>
                Your reliable partner for Water &amp; Wastewater Treatment Plant and Equipment, HVAC,
                and Fire-Fighting systems. We deliver compact, efficient, site-ready solutions built for performance.
              </p>
              <div className="hero-actions">
                <a href="#contact" className="btn btn-primary">Get in touch</a>
                <a href="#services" className="btn btn-secondary">Explore services</a>
              </div>
              <div className="hero-stats">
                <div><strong>75+</strong><span>Projects Delivered</span></div>
                <div><strong>7+</strong><span>Cities Served</span></div>
                <div><strong>India</strong><span>Operational Reach</span></div>
              </div>
            </div>
            <aside className="hero-card reveal delay-1">
              <h2>Integrated engineering solutions</h2>
              <ul>
                <li>Water Treatment Plants</li>
                <li>Wastewater Treatment Systems</li>
                <li>HVAC Installations</li>
                <li>Fire-Fighting Infrastructure</li>
              </ul>
              <div className="hero-card-glow"></div>
            </aside>
          </div>
          <div className="scroll-indicator" aria-hidden="true">
            <span></span>
          </div>
        </section>

        <section className="section" id="about">
          <div className="container">
            <div className="section-head reveal">
              <span className="eyebrow">About us</span>
              <h2>Built on commitment, backed by technical excellence.</h2>
            </div>
            <div className="about-grid">
              <div className="about-copy reveal">
                <p>
                  SAMRUDDHI ENVIROTECH SOLUTIONS has a team of highly determined, proactive,
                  enthusiastic, and committed professionals in the field of water, wastewater,
                  and solid waste management. We work with dedication to protect the environment
                  and public health from pollution hazards through effective management services.
                </p>
                <p>
                  We handle large-scale water and wastewater treatment projects with accuracy,
                  a skilled technical team, and minimal time. We operate across India and believe
                  in advanced technology solutions that ensure low maintenance and high customer satisfaction.
                </p>
              </div>
              <div className="about-cards reveal delay-1">
                <article className="info-card">
                  <h3>Technical depth</h3>
                  <p>Profound knowledge and Technical support in water Treatments, wastewater treatments, HVAC &amp; Fire-Fighting.</p>
                </article>
                <article className="info-card">
                  <h3>Mission</h3>
                  <p>To deliver high-quality engineering solutions with precision, innovation, technical advancement and client satisfaction in water Treatments, waste water treatments, HVAC and Fire-Fighting.</p>
                </article>
                <article className="info-card">
                  <h3>Why clients choose us</h3>
                  <p>Compact, efficient designs suitable for on-site conditions with a practical focus on durability, serviceability, and performance.</p>
                </article>
              </div>
            </div>
          </div>
        </section>

        <section className="section section-tint" id="services">
          <div className="container">
            <div className="section-head reveal">
              <span className="eyebrow">Services</span>
              <h2>Specialized solutions across critical infrastructure systems.</h2>
            </div>
            <div className="service-grid">
              {serviceCards.map((card) => (
                <article key={card.title} className={`service-card reveal${card.delay}`}>
                  <div className="service-media"><img src={card.image} alt={card.alt} /></div>
                  <div className="service-body">
                    <h3>{card.title}</h3>
                    <p>{card.text}</p>
                  </div>
                </article>
              ))}
            </div>

            <div className="industries reveal">
              <h3>Industries we serve</h3>
              <div className="pill-wrap">
                {industries.map((industry) => (
                  <span key={industry}>{industry}</span>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="section" id="projects">
          <div className="container">
            <div className="section-head reveal">
              <span className="eyebrow">Projects</span>
              <h2>Selected execution snapshots from recent work.</h2>
              <p>From site installations to process systems, our project execution reflects practical engineering, precision delivery, and field readiness.</p>
            </div>
            <div className="project-grid">
              {projectCards.map((card) => (
                <article key={card.title} className={`project-card reveal${card.delay}`}>
                  <img src={card.image} alt={card.alt} />
                  <div className="project-overlay">
                    <h3>{card.title}</h3>
                    <p>{card.text}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="section section-tint" id="gallery">
          <div className="container">
            <div className="section-head reveal">
              <span className="eyebrow">Work gallery</span>
              <h2>Our work showcase across treatment, HVAC, fire systems, and fabrication.</h2>
              <p>Browse a visual stream of delivered systems, in-progress execution, fabricated equipment, and installation details.</p>
            </div>
          </div>

          <div className="gallery-marquee">
            <div className="gallery-track">
              {repeatedGallery.map((image, index) => (
                <img
                  key={`${image.src}-${index}`}
                  src={image.src}
                  alt={index < galleryImages.length ? image.alt : ''}
                  aria-hidden={index >= galleryImages.length ? 'true' : undefined}
                />
              ))}
            </div>
          </div>
        </section>

        <section className="section" id="contact">
          <div className="container contact-grid">
            <div className="contact-copy reveal">
              <span className="eyebrow">Contact</span>
              <h2>Let’s discuss your next engineering requirement.</h2>
              <div className="contact-card">
                <h3><a href="tel:+918980239253">Mr. Daksh Modi · +91-89802-39253</a></h3>
                <p><a href="mailto:samruddhienvirotech@gmail.com">samruddhienvirotech@gmail.com</a></p>
              </div>
              <div className="contact-card">
                <h3>Corporate Office</h3>
                <p>559, Hilltown Trade Center (HTC), Kathwada Road, Dastan Circle, Near 108 Call Center, Nava Naroda, Ahmedabad, Gujarat, India - 382330</p>
              </div>
              <div className="contact-card">
                <h3>Fabrication Unit</h3>
                <p>Plot No. 80, Krishna Industrial Park-4, Kubadthal, Daskroi, Ahmedabad, Gujarat - 382433</p>
              </div>
              {/* <div className="contact-list">
                <a href="tel:+918980239253">Mr. Daksh Modi · +91-89802-39253</a>
                <a href="mailto:samruddhienvirotech@gmail.com">samruddhienvirotech@gmail.com</a>
              </div> */}
            </div>

            <form className="contact-form reveal delay-1" onSubmit={handleSubmit}>
              <div className="form-row">
                <label>Full Name
                  <input type="text" name="name" placeholder="Enter your name" required />
                </label>
                <label>Email
                  <input type="email" name="email" placeholder="Enter your email" required />
                </label>
              </div>
              <div className="form-row">
                <label>Phone
                  <input type="tel" name="phone" placeholder="Enter your phone number" />
                </label>
                <label>Subject
                  <input type="text" name="subject" placeholder="How can we help?" />
                </label>
              </div>
              <label>Message
                <textarea name="message" rows="6" placeholder="Tell us about your requirement" required></textarea>
              </label>
              <button type="submit" className="btn btn-primary btn-full" disabled={isSubmitting}>{submitLabel}</button>
            </form>
          </div>
        </section>
      </main>

      <a className="email-fab" href="mailto:samruddhienvirotech@gmail.com" target="_blank" rel="noopener" aria-label="Send Email">
        <svg viewBox="0 0 32 32" aria-hidden="true"><path d="M4 8c0-1.1.9-2 2-2h20c1.1 0 2 .9 2 2v.5l-12 7.5L4 8.5V8zm0 3.2 10.7 6.7c.8.5 1.8.5 2.6 0L28 11.2V24c0 1.1-.9 2-2 2H6c-1.1 0-2-.9-2-2V11.2z" fill="currentColor" /></svg>
      </a>
      <a className="whatsapp-fab" href="https://wa.me/918980239253" target="_blank" rel="noopener" aria-label="Chat on WhatsApp">
        <svg viewBox="0 0 32 32" aria-hidden="true"><path d="M19.11 17.33c-.26-.13-1.5-.74-1.73-.83-.23-.09-.4-.13-.57.13-.17.26-.66.83-.81 1-.15.17-.3.2-.56.07-.26-.13-1.09-.4-2.08-1.29-.77-.69-1.29-1.54-1.45-1.8-.15-.26-.02-.4.11-.53.12-.12.26-.3.39-.46.13-.15.17-.26.26-.43.09-.17.04-.33-.02-.46-.07-.13-.57-1.37-.78-1.88-.21-.5-.42-.43-.57-.44h-.49c-.17 0-.46.07-.7.33-.24.26-.92.9-.92 2.18 0 1.28.94 2.52 1.07 2.7.13.17 1.84 2.8 4.45 3.92.62.27 1.11.43 1.49.55.63.2 1.21.17 1.67.1.51-.08 1.5-.61 1.72-1.19.21-.58.21-1.08.15-1.19-.05-.11-.22-.17-.48-.3Z" fill="currentColor"/><path d="M16 3.2c-7.07 0-12.8 5.73-12.8 12.8 0 2.25.59 4.46 1.71 6.41L3.2 28.8l6.56-1.68a12.75 12.75 0 0 0 6.24 1.62c7.07 0 12.8-5.73 12.8-12.8S23.07 3.2 16 3.2Zm0 23.3c-2.04 0-4.03-.55-5.77-1.58l-.41-.24-3.89 1 1.04-3.79-.27-.43a10.55 10.55 0 1 1 9.3 5.04Z" fill="currentColor"/></svg>
      </a>
    </>
  );
}

export default App;
